import React from 'react';
import PropTypes from 'prop-types';

import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';
import messages from '../../lib/messages.js';
import textIcon from './text.svg';

const BitTextComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.text}
    imgSrc={textIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="T"
  />
);

BitTextComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default BitTextComponent;
